import React from "react";
import { t } from "../i18n";
import { If } from "./If";

export const SiFooter: React.FC<{ authenticated: boolean }> = ({
  authenticated
}) => {
  return (
    <If predicate={authenticated}>
      <footer className="app">
        <div className="footer-content">
          <div className="left">
            <div className="row">
              <div className="column">
                <ul>
                  <li>
                    <a href="#/watchlist">Watchlist</a>
                  </li>
                  <li>
                    <a href="#/history">History</a>
                  </li>
                  <li>
                    <a href="#/profile">Account</a>
                  </li>
                  {/*<li><a href="#/faq">FAQ</a></li>*/}
                </ul>
              </div>

              <div className="column">
                <ul>
                  <li>
                    <a href="#/videos/early-childhood">
                      {t("Early Childhood")}&nbsp;
                      <span>Videos</span>
                    </a>
                  </li>
                  <li>
                    <a href="#/videos/elementary-school">
                      {t("Elementary School")}&nbsp;
                      <span>Videos</span>
                    </a>
                  </li>
                  <li>
                    <a href="#/videos/middle-school">
                      {t("Middle School")}&nbsp;<span>Videos</span>
                    </a>
                  </li>
                  <li>
                    <a href="#/videos/high-school">
                      {t("High School")}&nbsp;<span>Videos</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="right">
            <img src="images/logo.png" alt="" />

            <div className="social-icons">
              <a
                href="https://www.facebook.com/Successfulinnovationsinc/"
                rel="noopener noreferrer"
                target="_blank"
              >
                <i className="fa fa-facebook" aria-hidden="true" />
              </a>

              <a
                href="https://twitter.com/Successfulinc"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-twitter" aria-hidden="true" />
              </a>

              <a
                href="https://www.youtube.com/user/sprokity"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-youtube" aria-hidden="true" />
              </a>

              <a href="tel:+8777732448">
                <i className="fa fa-phone" aria-hidden="true" />

                <span>(877) 773-2448</span>
              </a>
            </div>
          </div>
        </div>

        <div className="stretch-background-left" />
      </footer>
    </If>
  );
};
